import { LotTypeEnum, PriorityEnum } from "../../../../common-models/src/lib/enum";

export class LotCreationReq{
    lotType : LotTypeEnum;
    remarks : string;
    createdUser : string;
    exFactoryDate : any;
    priority : PriorityEnum;
    date : any
    
    constructor(lotType : LotTypeEnum,remarks : string,createdUser : string,exFactoryDate : any,priority : PriorityEnum,date : any){
        this.lotType = lotType
        this.remarks = remarks
        this.createdUser = createdUser
        this.exFactoryDate = exFactoryDate
        this.priority = priority
        this.date = date
    }
}